module.exports = __webpack_public_path__ + "img/nallai_logo.c52fa523.png";